import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminChatMessage = (params) => {
  return axiosClient
    .post(`/api/admin/im/view/${params.id}`, params)
    .then((r) => r.data);
};
